import { useApiTokensQuery } from "modules/settings/hooks/useApiTokensQuery"
import { ApiTokensTable } from "./ApiTokensTable"
import { CompanyVault } from "./CompanyVault"

export function KeysAndSecrets() {
  const { data: apiTokens, isPending: isApiTokensPending } = useApiTokensQuery()

  return (
    <div className="flex flex-col gap-10">
      <CompanyVault />
      <ApiTokensTable data={apiTokens} isPending={isApiTokensPending} />
    </div>
  )
}
